import { render, staticRenderFns } from "./packInvite.vue?vue&type=template&id=18601f8d&scoped=true"
import script from "./packInvite.vue?vue&type=script&lang=js"
export * from "./packInvite.vue?vue&type=script&lang=js"
import style0 from "./packInvite.vue?vue&type=style&index=0&id=18601f8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18601f8d",
  null
  
)

export default component.exports